import * as THREE from 'three';

const rotationFactor = 3.14 / 180;

// Set transalation, rotation, scale on Object3D
function setTRS(object3d, t, r, s) {
  object3d.position.set(t.x, t.y, t.z);
  object3d.rotation.set(r.x, r.y, r.z, 'ZYX');
  object3d.scale.set(s.x, s.y, s.z);
};

function setTRSDegrees(object3d, t, r, s) {
  object3d.position.set(t.x, t.y, t.z);
  object3d.rotation.set(r.x * rotationFactor, r.y * rotationFactor, r.z * rotationFactor, 'ZYX');
  object3d.scale.set(s.x, s.y, s.z);
};

/* Apply matrix4 to threejs node.
 */
export function setMatrixOn(object3d, matrix4) {
  let translation = new THREE.Vector3();
  let rotQuat = new THREE.Quaternion();
  let scale = new THREE.Vector3();
  matrix4.decompose(translation, rotQuat, scale);
  let rotation = new THREE.Vector3().copy(new THREE.Euler().setFromQuaternion(rotQuat, 'ZYX'));
  setTRS(object3d, translation, rotation, scale);
}



// WEBPACK FOOTER //
// ./src/translators/transform.js